// extracted by mini-css-extract-plugin
module.exports = {"block":"block-1dab51","more":"more-1dab51"};